import { ReactNode } from 'react'
import { useAuth } from 'torqcloud-ui'
import OrganizationInactivePage from '@/pages/auth/organization-inactive/OrganizationInactivePage'

export default function OrganizationStatusGuard({ children }: { children: ReactNode }) {
  const { organizations, hasMetadata } = useAuth()

  if (!hasMetadata) {
    return null
  }

  if (!organizations || organizations.length === 0) {
    return <OrganizationInactivePage status="no_org" />
  }

  const primaryOrg = organizations[0]

  if (primaryOrg.active === false) {
    if (primaryOrg.is_owner) {
      return (
        <OrganizationInactivePage
          status="owner_inactive"
          organizationName={primaryOrg.organization_name}
        />
      )
    }

    return (
      <OrganizationInactivePage
        status="member_inactive"
        organizationName={primaryOrg.organization_name}
      />
    )
  }

  return <>{children}</>
}
